<section aeBillboardLabel class="billboard billboard-slim billboard-first">
	<div class="billboard-header">
		<h2 class="billboard-title">Completed Assignments</h2>
		<div class="billboard-actions">
			<div class="btn-group mw-100">
				<button
					class="btn ms-auto"
					title="Previous Week"
					type="button"
					[ngClass]="
						isStudentView() ? 'btn-secondary text-white' : 'btn-default'
					"
					(click)="filterSearchDates(false)"
				>
					<i aria-hidden="true" class="fas fa-caret-left"></i>
				</button>
				<span
					class="d-flex align-items-center overflow-hidden px-1 user-select-none text-center"
					[ngClass]="isStudentView() ? 'bg-secondary text-white' : 'bg-default'"
					>{{ fromDate | spaceFormat: 'numeric-us' }}
					-
					{{ toDate | spaceFormat: 'numeric-us' }}</span
				>
				<button
					class="btn ms-auto"
					title="Next Week"
					type="button"
					[disabled]="atCurrentDate"
					[ngClass]="
						isStudentView() ? 'btn-secondary text-white' : 'btn-default'
					"
					(click)="filterSearchDates(true)"
				>
					<i aria-hidden="true" class="fas fa-caret-right"></i>
				</button>
			</div>
		</div>
	</div>
	<div
		class="billboard-body position-relative"
		[aeBillboardCollapsable]="
			isStudentView()
				? false
				: 'lunchbox.pages.overview.assignments.section.collapse'
		"
	>
		<!-- Assignment Details -->
		<div class="assignment-details-container squared-top">
			<div
				class="assignment-detail-display border-bottom overflow-y-auto"
				[class.d-none]="!showDetails"
			>
				<ae-pgt
					#t
					name="{{ currentStudentId() | userName }} - Assignments"
					[tableConfig]="tableConfig"
				>
					<ae-pgt-column columnId="class_title" [starWidth]="4">
						<ng-template aePgtHeader>Class</ng-template>
						<ng-template let-item [aePgtDisplay]="t">
							{{ item.class_title }}
						</ng-template>
					</ae-pgt-column>
					<ae-pgt-column columnId="assignment_title" [starWidth]="6">
						<ng-template aePgtHeader>Assignment</ng-template>
						<ng-template let-item [aePgtDisplay]="t">
							{{ item.assignment_title }}
						</ng-template>
					</ae-pgt-column>
					<ae-pgt-column columnId="submission_date" [starWidth]="2">
						<ng-template aePgtHeader>Submitted</ng-template>
						<ng-template let-item [aePgtDisplay]="t">
							{{
								item.submission_date
									| spaceMap: timezone
									| spaceFormat
										: '{month-iso}/{date-pad}/{year} {hour-pad}:{minute-pad}{ampm}'
							}}</ng-template
						>
					</ae-pgt-column>
				</ae-pgt>
			</div>
			<div class="text-center">
				<button
					class="btn btn-sm btn-gray my-0 squared-top"
					id="lunchbox.pages.overview.assignment.detail.button"
					type="button"
					(click)="showDetails = !showDetails"
				>
					<div class="d-flex align-content-center">
						<div>
							<i aria-hidden="true" class="far fa-file-check"></i>
							{{ (assignmentDetails | async)?.length || 0 }}
							<span class="pe-1">Assignment Details</span>
						</div>
						@switch (showDetails) {
							@case (true) {
								<i class="fas fa-sort-up"></i>
							}
							@default {
								<i class="fas fa-sort-down"></i>
							}
						}
					</div>
				</button>
			</div>
		</div>
		<!-- Chart -->
		<div class="overview-assignments-component-container mt-4">
			<div
				#graphContainer
				class="overview-assignments-chart-container"
				[ngClass]="isStudentView() ? 'bg-light' : 'bg-white'"
			>
				@if (noStudentData && !loadingAssignments && !hasError) {
					<div class="overview-assignments-chart-noassignments">
						<div
							class="p-3 fs-3"
							[ngClass]="isStudentView() ? 'bg-light' : 'bg-white'"
						>
							No Assignments Found
							<i aria-hidden="true" class="far fa-empty-set"></i>
						</div>
					</div>
				}
				@if (hasError && !loadingAssignments) {
					<div class="overview-assignments-chart-noassignments">
						<div class="fs-3">An Error has Occurred</div>
					</div>
				}
				Updated
				<div *aeSpinWhile="loadingAssignments">
					<ae-stacked-vertical-bar-chart
						[customColors]="colorOverride"
						[legend]="true"
						[legendPosition]="'Below'"
						[results]="studentAssignmentsData"
						[scheme]="{
							name: null,
							selectable: false,
							group: null,
							domain: colors,
						}"
						[view]="view"
						[xAxis]="true"
						[yAxis]="true"
					>
						<ng-template #tooltipTemplate let-model="model">
							<div class="p-1">
								<div class="fs-normal">
									{{ model.name }}
								</div>
								<div>
									<span class="fw-bold">{{ model.value }}</span>
									of
									<span class="fw-bold">{{
										getTotalValueOfSeries(model.series)
									}}</span>
								</div>
							</div>
						</ng-template>
					</ae-stacked-vertical-bar-chart>
				</div>
			</div>
		</div>
	</div>
</section>
